import { getWidth } from '../helpers/getWidth';
import { useEffect, useState } from 'react';
import { useEditStage } from './useEditStage';

export const useResizeStage = (stage, activeTab) => {
    let width = getWidth(Number(stage.planned.days_count), activeTab);

    const [elWidth, setElWidth] = useState(width);
    const [needResizeUpdate, setNeedResizeUpdate] = useState(false);

    const { increaseStage, decreaseStage } = useEditStage(stage);

    const changeWidth = (movementX) => {
        setElWidth((prevState) => {
            return prevState + movementX;
        });
    };

    const onItemChange = () => {
        setNeedResizeUpdate(true);
    };

    useEffect(() => {
        if (needResizeUpdate) {
            let days_count = Math.round(elWidth / 24 + 1);

            if (activeTab === 'week') {
                days_count = Math.round((elWidth + 23) / 11) - 1;
            }

            if (activeTab === 'month') {
                days_count = Math.round((elWidth + 23) / 7) - 2;
            }

            days_count = days_count < 1 ? 1 : days_count;

            const startDate = stage.planned.start_date;

            if (+stage.planned.days_count !== days_count) {
                const isDecrease = +stage.planned.days_count > days_count;
                const difference = +stage.planned.days_count - days_count;

                if (!isDecrease) {
                    increaseStage(stage, { days: `${days_count}`, date: startDate }, difference);
                } else {
                    decreaseStage(stage, difference);
                }
            }
            setElWidth(width);
            setNeedResizeUpdate(false);
        }
    }, [needResizeUpdate]);

    useEffect(() => {
        setElWidth(width);
    }, [stage]);
    return {
        elWidth,
        needResizeUpdate,
        setNeedResizeUpdate,
        setElWidth,
        changeWidth,
        onItemChange,
    };
};
